import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  Input,
  Output,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { GasTable } from '../gas-table.namespace';

@Component({
  selector: 'gas-simple-table',
  templateUrl: './gas-simple-table.component.html',
  styleUrls: ['./gas-simple-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GasSimpleTableComponent {

  @ViewChildren('tableHeadRow', { read: ElementRef })
  public tableHeadRow: QueryList<ElementRef>;

  @ViewChildren('tableBodyRow', { read: ElementRef })
  public tableBodyRows: QueryList<ElementRef>;

  @ViewChild('gasScrollComponent', { read: ElementRef })
  public gasScrollComponent: ElementRef;

  @HostBinding('class.auto-columns')
  public autoColumns = false;

  @Input()
  public isValueEmpty: boolean;

  @Input()
  public loading = false;

  @Input()
  public error = false;

  @Input()
  public data: GasTable.TableValue[] = [];

  @Input()
  public headerTemplate;

  @Input()
  public bodyTemplate;

  @Input()
  public disableRowSelectionFilter: ((rowData: Record<string, unknown>) => boolean) | undefined;

  @Output('onRowClick')
  public onRowClick$ = new EventEmitter<any>();

  public rowClick(rowData: GasTable.TableValue): void {
    this.onRowClick$.emit(rowData);
  }
}
